import { isArray, includes, toLower } from 'lodash';
import Logger from '../../utils/Logger';
import {
  NOONA,
  PYYDETTY,
  KAYTTAJA,
  SUOSTUMUS,
  LUKITTU,
} from '../../definitions/NoonaConstants';

const createActionName = require('../util').createActionName('services');

const { id: module_id } = module;
const logger = Logger(module_id);

export const REQUEST_SERVICES = createActionName('REQUEST_SERVICES');
export const REQUEST_SERVICES_FAILED = createActionName(
  'REQUEST_SERVICES_FAILED'
);
export const RECEIVE_SERVICES = createActionName('RECEIVE_SERVICES');
export const REQUEST_PASSWORD_CHANGE = createActionName(
  'REQUEST_PASSWORD_CHANGE'
);
export const REQUEST_PASSWORD_CHANGE_SUCCESSFUL = createActionName(
  'REQUEST_PASSWORD_CHANGE_SUCCESSFUL'
);
export const REQUEST_PASSWORD_CHANGE_FAILED = createActionName(
  'REQUEST_PASSWORD_CHANGE_FAILED'
);
export const GO_TO_ACTIVATE_SERVICE = createActionName(
  'GO_TO_ACTIVATE_SERVICE'
);
export const CREATE_NOTIFICATION = createActionName('CREATE_NOTIFICATION');
export const DISMISS_NOTIFICATION = createActionName('DISMISS_NOTIFICATION');
export const REQUEST_DISMISS_SERVICE_ACTIVATION_NOTIFICATION_FAILED =
  createActionName('REQUEST_DISMISS_SERVICE_ACTIVATION_NOTIFICATION_FAILED');

/**
 * Action for indicating start of requesting services from backend
 * */
export const requestServices = () => ({
  type: REQUEST_SERVICES,
});

/**
 * Action for indicating requesting services from backend produced some kind of error
 * */
export const requestServicesFailed = (error) => ({
  type: REQUEST_SERVICES_FAILED,
  error: error,
});

/**
 * Action for indicating services are received.
 * Note: This action is also used when initializing services from model.
 * */
export const receiveServices = (data) => ({
  type: RECEIVE_SERVICES,
  data: data,
});

/**
 * Filter for validating noona service integration.
 * */
const validateNoona = (item) => {
  if (item.name === NOONA) {
    // process only noona
    if (!includes([PYYDETTY, SUOSTUMUS, KAYTTAJA], toLower(item.status))) {
      // if item has something other than a valid status, do not include.
      // note that LUKITTU is not a valid status for this case.
      return false;
    }
  }
  return true;
};

/**
 * Validation method for service data. An array is expected.
 * */
const validateServiceData = (data) => {
  // validate data
  if (!isArray(data)) {
    throw new Error(
      'ServiceValidations wanted array but did not receive array'
    );
  }

  data = data.filter(validateNoona);

  return data;
};

/**
 * Action for initializing service integrations from given data
 * */
export const initializeServiceIntegrations = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    data = validateServiceData(data);
    return resolve(dispatch(receiveServices(data)));
  });
};

/**
 * Action for fetching services from server
 * */
export const getServices = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestServices());
    services.api
      .getPatientServiceIntegrations()
      .then((data) => {
        validateServiceData(data);
        resolve(dispatch(receiveServices(data)));
      })
      .catch((error) => {
        reject(dispatch(requestServicesFailed(error)));
      });
  });
};
